import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_show_user_answer_question_body",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-900px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header pb-0 border-0 justify-content-end" }
const _hoisted_5 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = {
  class: "modal-body scroll-y pt-0 pb-15",
  "element-loading-text": "درحال بارگزاری..."
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = { class: "symbol symbol-40px flex-shrink-0 me-2" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "ml-4" }
const _hoisted_13 = { class: "text-dark-75 font-weight-bolder font-size-lg mb-0" }
const _hoisted_14 = { class: "text-muted small font-weight-bold text-hover-primary" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed mt-5" }, null, -1)
const _hoisted_16 = { class: "d-flex align-items-center py-3 mb-0" }
const _hoisted_17 = { class: "btn btn-sm btn-icon mw-20px btn-active-color-primary me-5" }
const _hoisted_18 = { class: "d-flex bg-gray-300 text-gray-900 fs-5 w-20px h-20px p-2 rounded-circle text-center align-items-center" }
const _hoisted_19 = { class: "text-gray-700 fs-6 fw-bold cursor-pointer mb-0" }
const _hoisted_20 = { class: "fs-6 ms-1" }
const _hoisted_21 = { class: "mb-4 text-gray-600 fw-semibold fs-6 ps-10" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_ctx.list && _ctx.list.answers)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("span", null, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("img", {
                        class: "",
                        src: _ctx.list.chat.avatar,
                        alt: "photo"
                      }, null, 8, _hoisted_11)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.list.chat.name), 1),
                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.list.chat.chat_id), 1)
                    ])
                  ])
                ]),
                _hoisted_15,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list.answers, (answer, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "m-0",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("span", _hoisted_18, _toDisplayString(index + 1), 1)
                      ]),
                      _createElementVNode("h4", _hoisted_19, _toDisplayString(answer.question.text), 1)
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, _toDisplayString(answer.answer), 1)
                    ]),
                    _hoisted_22
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])), [
          [_directive_loading, _ctx.loading]
        ])
      ])
    ])
  ]))
}